import React from 'react';

/**
 * RUBY'S GLYPH: a robot, not a sparkle.
 *
 * The four-point sparkle is the generic "AI" mark every product shipped in the
 * same year, and it reads as decoration rather than as a thing that does work.
 * A robot says an agent is going to go and act on this -- which is exactly what
 * the button it sits on does.
 *
 * Inline stroke SVG, `currentColor`, `aria-hidden` -- an emoji would render in
 * the platform's own font, ignore the button's colour, and be read out by a
 * screen reader as a picture of a robot next to a label that already says what
 * the button does.
 *
 * Lives in its own module because both the console's primary action and the
 * `/app-issues` row button use it; importing it from either page would pull
 * that whole screen into the other.
 */
export const RobotIcon: React.FC<{ size?: number }> = ({ size = 17 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* the head */}
    <rect x="4" y="8" width="16" height="12" rx="3" />
    {/* the antenna */}
    <path d="M12 8V4.5" />
    <circle cx="12" cy="3" r="1.4" />
    {/* the eyes */}
    <path d="M9 13v1.6M15 13v1.6" />
    {/* the mouth */}
    <path d="M9.5 17.4h5" />
    {/* the ears */}
    <path d="M4 12.5H2.4M20 12.5h1.6" />
  </svg>
);
